/**
 * Image Preloader Utility
 * Predictive preloading for smoother page transitions
 */

function preloadImage(url: string): Promise<void> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve();
    img.onerror = () => reject(new Error(`Failed to preload image: ${url}`));
    img.src = url;
  });
}

async function preloadImages(urls: string[]): Promise<void> {
  try {
    await Promise.all(urls.map(url => preloadImage(url)));
  } catch (error) {
    console.warn('Some images failed to preload:', error);
  }
}

/**
 * Preload images for a specific page on hover
 * Used for predictive preloading when user hovers over links
 */
export function preloadPageImages(pagePath: string): void {
  if (typeof window === 'undefined') return;
  
  const pageImageMap: Record<string, string[]> = {
    '/all-you-can-eat': [
      '/images/ayce-case-studies/ayce-qr-ordering-shabu-shabu-menu-1.webp',
      '/images/ayce-case-studies/ayce-tablet-ordering-shabu-shabu-menu-1.webp',
      '/images/ayce-case-studies/ayce-qr-ordering-okinii-menu-1.webp',
      '/images/ayce-case-studies/ayce-tablet-ordering-okinii-menu-1.webp',
    ],
  };
  
  const images = pageImageMap[pagePath];
  if (images && images.length > 0) {
    preloadImages(images).catch(err => 
      console.warn(`Failed to preload images for ${pagePath}:`, err)
    );
  }
}
